// src/components/home/HeroSection.tsx
import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import "./style/HeroSection.scss"
import cryptoGold from "../../assets/images/gold-crypto.png"

const Hero: React.FC = () => {
  const { t, i18n } = useTranslation()

  const sentences: string[] = useMemo(
    () =>
      (t("home.hero.sentences", { returnObjects: true }) as unknown as string[]) ||
      [],
    [t, i18n.language]
  )

  const [idx, setIdx] = useState(0)
  const [phase, setPhase] = useState<"in" | "out">("in")

  // 2) Whenever sentences or language change, reset index & phase
  useEffect(() => {
    setIdx(0)
    setPhase("in")
  }, [i18n.language])

  // 3) Cycle effect: fade out → swap → fade in, every 5 seconds
  useEffect(() => {
    if (sentences.length === 0) return

    let cycleTimer: NodeJS.Timeout
    let switchTimer: NodeJS.Timeout

    const startCycle = () => {
      cycleTimer = setInterval(() => {
        setPhase("out")

        // after fade‐out (0.5s), swap text and fade in
        switchTimer = setTimeout(() => {
          setIdx((i) => (i + 1) % sentences.length)
          setPhase("in")
        }, 500)
      }, 5000)
    }

    startCycle()

    return () => {
      clearInterval(cycleTimer)
      clearTimeout(switchTimer)
    }
  }, [sentences])

  // 4) Render each char with a small stagger
  const renderAnimatedText = (text: string) => {
    let letterIndex = 0
    return text.split("").map((char, i) => {
      if (char === "\n") return <br key={`br-${i}`} />

      const delay = letterIndex * 0.08
      letterIndex += 1

      return (
        <span
          key={`char-${i}`}
          style={{ animationDelay: `${delay}s` }}
        >
          {char === " " ? "\u00A0" : char}
        </span>
      )
    })
  }

  // 5) Guard if no sentences loaded
  if (sentences.length === 0) {
    return null
  }

  return (
    <section className="hero-section">
      <div className="particles" />

      <div className="hero-content">
        <h1 className={`typewriter ${phase}`}>
          {renderAnimatedText(sentences[idx])}
        </h1>
        <p>{t("home.hero.subtext")}</p>
      </div>

      <div className="hero-image">
        <img
          src={cryptoGold}
          alt={t("home.hero.subtext")}
        />
      </div>
    </section>
  )
}

export default Hero
